import React, { useEffect, useState } from "react";
import styles from "./MobileNumber.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import SendOtp from "@modals/sendotp/SendOtp";
import { verifyPhoneNumber } from "@services/signUpService";
import { setComponentToShow } from "@store/ModalToShow";
import { setMobileNumber, setIsdCode } from "@store/login/LoginStore";
import { useDispatch } from "react-redux";

const MobileNumber = () => {
  const dispatch = useDispatch();
  const pageLocation = useLocation();
  const navigate = useNavigate();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryCode, setCountryCode] = useState("+91");
  const phone=localStorage.getItem("phoneNumber");

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, ""); // prevents alphabets
    setPhoneNumber(value);
    dispatch(setIsdCode(countryCode));
    dispatch(setMobileNumber(value));
    localStorage.setItem("phoneNumber", value);
    localStorage.setItem("countryCode", countryCode);
    localStorage.setItem(
      "phoneData",
      JSON.stringify({ dialCode: countryCode, number: value })
    );
  };

  const handleStartClick = async () => {
    const phoneDataFromStorage = localStorage.getItem("phoneData");
    if (!phoneDataFromStorage) return;

    const res = await verifyPhoneNumber(JSON.parse(phoneDataFromStorage));
    if (res.existingUser) {
      // navigate(`${pageLocation.pathname}#sendOtp`, { replace: true });
      dispatch(setComponentToShow("SendOtp"));
    } else {
      alert("Not an existing user");
    }
  };

  return (
    <div className={styles.mobile_input_container}>
      <div className={styles.input_group}>
        <select
          value={countryCode}
          className={styles.dial_code_select}
          onChange={(e) => setCountryCode(e.target.value)}
        >
          <option value="+91">+91</option>
          <option value="+1">+1</option>
        </select>

        <input
          type="tel"
          className={styles.mobile_number_input}
          placeholder="Enter your mobile number"
          onChange={handlePhoneChange}
          value={phoneNumber}
          maxLength={10}
        />

        <button
          type="button"
          className={styles.btn_primary}
          disabled={phoneNumber.length !== 10}
          onClick={handleStartClick}
        >
          START
        </button>
      </div>
{/* 
      {currentSection === "#sendOtp" && (
        <SendOtp
          isOpen={true}
          onClose={() =>
            navigate(`${pageLocation.pathname}`, { replace: true })
          }
        />
      )} */}
    </div>
  );
};

export default MobileNumber;
